import { render } from "./PaiementHospitalisationModal.vue?vue&type=template&id=a585a1d0&scoped=true"
import script from "./PaiementHospitalisationModal.vue?vue&type=script&lang=js"
export * from "./PaiementHospitalisationModal.vue?vue&type=script&lang=js"

import "./PaiementHospitalisationModal.vue?vue&type=style&index=0&id=a585a1d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a585a1d0"]])

export default __exports__